import { useCallback } from "react";
import axiosInstance from "../../service/axiosInstance";
import { inventoryAPI } from "../../service/api";
import { GET } from "../constants";
import { IInvIneligibleReport } from "../../interfaces";
import useExchangeRates from "./useExchangeRates";
import { inventoryIneligibleReportMock } from "../../mock-data/inventory-ineligible-report";

const useInvIneligibleReport = () => {
  const {
    convertAmountByRate
  } = useExchangeRates();
  
  const getInvIneligibleReport = useCallback(async (borrowerId: number, bbPeriodId: number, invCollateralId: number) => {
    try {
      const response = await axiosInstance.request({
        url: inventoryAPI.GET_INELIGIBLE_REPORT,
        method: GET,
        params: {
          borrowerId,
          bbPeriodId,
          invCollateralId,
        }
      });
      return response.data as IInvIneligibleReport[];

      // return inventoryIneligibleReportMock as IInvIneligibleReport[];
    } catch (error) {
      console.log('GET INVENTORY INELIGIBLE REPORT ERROR: ', error);
      return [];
    }
  }, []);

  const getReportWithRates = useCallback(async (borrowerId: number, bbPeriodId: number, invCollateralId: number, rate: number) => {
    const report = await getInvIneligibleReport(borrowerId, bbPeriodId, invCollateralId);
    
    if (rate !== 1) {
      const appliedRates = report
        .filter(rep => rep.ineligibleCode != 'Gross Inventory')
        .map(rep => ({
        ...rep,
        valueOnHand: convertAmountByRate(rep.valueOnHand, rate),
        twelveMonthSalesValue: convertAmountByRate(rep.twelveMonthSalesValue, rate),
        amount: convertAmountByRate(rep.amount, rate),
        eligibleBalance: convertAmountByRate(rep.eligibleBalance, rate),
      }));
      return appliedRates;
    } else {
      return report;
    }
  }, [])

  return {
    getInvIneligibleReport,
    getReportWithRates
  };
};

export default useInvIneligibleReport;
